// vavci-menu-hover-fix.js — Arreglo del mega-menú de Horizon (apertura por hover).
//
// BUG: al subir con el ratón desde fuera del header hacia un link (entrada
// vertical), al abrirse el submenú se dispara un `pointerleave`/`pointerout`
// espurio cuyo `relatedTarget` sigue estando DENTRO del mismo ítem de menú
// (el enlace o el propio panel). El `deactivate` nativo de Horizon no reconoce
// ese caso como "sigo dentro del ítem" y CIERRA el menú recién abierto. La
// reconciliación por elementFromPoint suele reabrirlo (parpadeo), pero a veces
// no → el menú "se traba" y no abre. En horizontal no ocurre porque no se cruza
// esa zona de borde.
//
// FIX (no destructivo): envolvemos `HeaderMenu.prototype.deactivate` para
// ignorar los "leave" cuyo relatedTarget está contenido en el mismo
// `.menu-list__list-item`. El cierre legítimo (salir del ítem hacia fuera u otro
// ítem, o relatedTarget nulo al salir de la ventana) se conserva intacto.
//
// Se aplica al prototipo vía customElements.whenDefined, así cubre todas las
// instancias presentes y futuras sin depender del orden de carga.

(function () {
  customElements.whenDefined('header-menu').then(function () {
    var Ctor = customElements.get('header-menu');
    if (!Ctor || Ctor.prototype.__vavciHoverFix) return;
    Ctor.prototype.__vavciHoverFix = true;

    var original = Ctor.prototype.deactivate;
    Ctor.prototype.deactivate = function (event) {
      var target = event && event.target;
      var related = event && event.relatedTarget;
      if (target instanceof Element && related instanceof Node) {
        var item = target.closest('.menu-list__list-item');
        // El puntero sigue dentro del mismo ítem (enlace o panel): no cerrar.
        if (item && item.contains(related)) return;
      }
      return original.call(this, event);
    };
  });
})();
